module.exports = {
  "$id": "authenticate",
  "type": "object",
  "title": "银联认证",
  "properties": {
    "surname": {
      "title": "中文姓",
      "type": "string",
      "customValidate": "zhLastName"
    },
    "name": {
      "title": "中文名",
      "type": "string",
      "customValidate": "zhFirstName"
    },
    "identityCard": {
      "title": "身份证号",
      "type": "string",
      "customValidate": "identityCard"
    },
    "bankCardNo": {
      "title": "银行卡号",
      "type": "string"
    },
    "mobile": {
      "title": "手机号",
      "type": "string",
      "customValidate": "mobile"
    },
    "areaCode": {
      "title": "区位码",
      "type": "string"
    }
  },
  "required": [
    "surname",
    "name",
    "identityCard",
    "bankCardNo",
    "mobile"
  ],
  "errorMessage": {
    "surname": {
      "required": "中文姓不能为空"
    },
    "name": {
      "required": "中文名不能为空"
    },
    "bankCardNo": {
      "required": "银行卡号不能为空"
    },
    "identityCard": {
      // "message": "身份证号码不正确",
      "required": "请输入身份证号码"
    },
    "mobile": {
      "required": "手机号码不能为空"
    }
  }
}
